import { render, staticRenderFns } from "./perimetroCefalicoNinas.vue?vue&type=template&id=35273fa5&scoped=true&"
import script from "./perimetroCefalicoNinas.vue?vue&type=script&lang=js&"
export * from "./perimetroCefalicoNinas.vue?vue&type=script&lang=js&"
import style0 from "./perimetroCefalicoNinas.vue?vue&type=style&index=0&id=35273fa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35273fa5",
  null
  
)

export default component.exports